/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function sectionLabel() {

  ScrollTrigger.batch(".fullView__section", {
    onEnter: function(target) {
      var element = $(target);
      var title = element.attr('data-section-title');
      // alert(title);
      $('.sectionLabel').text(title);
      // alert('enter');
    },
    start: "top 50%",
    end: 99999,
    scroller: '.fullView'
    // markers: true
  });

  ScrollTrigger.batch(".fullView__section", {
    onLeaveBack: function(target) {
      var element = $(target);
      var title = element.attr('data-section-title');
      // alert(title);
      $('.sectionLabel').text(title);
      // alert('enter back');
    },
    start: "bottom 50%",
    end: 99999,
    scroller: '.fullView'
    // markers: true
  });


}
